import React from 'react';
import PropTypes from 'prop-types';

const COLORS = {
  color: { primary: '#005581', secondary: '#73c167' },
  bw: { primary: '#4F4F4F', secondary: '#AFAFAF' },
};

const InsightLogo = (props) => {
  const height = props.height || 36;
  const variant = props.variant || 'color';
  return (
    <svg
      className="app_branding apinsight_logo"
      height={height}
      viewBox="0 0 411 95"
      role="img"
      preserveAspectRatio="xMinYMin meet"
      style={props.style}
    >
      <title>AP Insight Logo</title>
      <path
        d="M81.2,71.6l-29.8,-70.9l-12.6,0l-30.1,70.9l-8.7,0l0,7.7l27.2,0l0,-7.3l-8.2,0l10.3,-24.3l30.4,0l9.8,23.9l-6.8,0l0,7.7l26.8,0l0,-7.7l-8.3,0ZM32.5,40l12.1,-29l11.9,29l-24,0Z"
        fill={COLORS[variant].primary}
      />
      <path
        d="M93,47.7c16.6,0 31.6,-3.5 31.6,-23.5c0,-20.1 -15,-23.4 -31.6,-23.4l-30.4,0l0,7.7l8.2,0l0,63.2l-8.4,0l0,7.7l27.1,0l0,-7.7l-8.2,0l0,-24l11.7,0ZM81.3,8.4l11.6,0c10.2,0 20.3,1 20.3,15.7c0,14.7 -10.1,15.9 -20.3,15.9l-11.6,0l0,-31.6Z"
        fill={COLORS[variant].secondary}
      />
      <path
        d="M124.2,3.3c0,-1.5 1.2,-2.7 2.7,-2.7c1.5,0 2.7,1.2 2.7,2.7c0,1.5 -1.2,2.7 -2.7,2.7c-1.5,0.1 -2.7,-1.2 -2.7,-2.7M129.1,3.3c0,-1.3 -0.9,-2.3 -2.2,-2.3c-1.3,0 -2.2,1 -2.2,2.3c0,1.3 0.9,2.3 2.2,2.3c1.3,0 2.2,-1 2.2,-2.3M125.8,1.7l1.2,0c0.8,0 1.1,0.3 1.1,0.9c0,0.6 -0.3,0.8 -0.8,0.9l0.9,1.4l-0.5,0l-0.9,-1.4l-0.5,0l0,1.4l-0.5,0l0,-3.2l0,0ZM126.9,3.1c0.5,0 0.8,0 0.8,-0.5c0,-0.4 -0.3,-0.5 -0.7,-0.5l-0.7,0l0,1l0.6,0Z"
        fill={COLORS[variant].primary}
      />
      <g>
        <path
          d="M144.4,75.4l8.1,0l0,-50.7l-8.1,0l0,-3.9l21.1,0l0,3.9l-8,0l0,50.7l8.1,0l0,3.9l-21.1,0l0,-3.9l-0.1,0Z"
          fill={COLORS[variant].primary}
        />
        <path
          d="M169.4,75.9l7.2,0l0,-33.5l-7.2,0l0,-3.4l11.6,0l0,6.3l0.2,0c2.4,-4.7 7.4,-7.2 12.6,-7.2c15.4,0 14.4,11.5 14.4,20.6l0,17.2l6.7,0l0,3.4l-18.4,0l0,-3.4l7.2,0l0,-17.2c0,-9.8 0.4,-17 -10.2,-16.7c-10.5,0 -12.5,8.3 -12.5,16.7l0,17.2l7.2,0l0,3.4l-18.8,0l0,-3.4l0,0Z"
          fill={COLORS[variant].primary}
        />
        <path
          d="M220.2,65.4l3.9,0c0.7,7.1 5.8,11.4 12.8,11.4c5.6,0 11.4,-2.4 11.4,-8.9c0,-12.1 -27.3,-1.7 -27.3,-18.5c0,-8.2 8.9,-11.4 15.8,-11.4c4.6,0 9.5,1.7 11.8,5.7l0.2,0l0,-4.7l3.9,0l0,13.1l-3.9,0c-0.4,-7.9 -5.3,-10.6 -12.5,-10.6c-4.9,0 -10.2,2.4 -10.2,8.1c0,11.2 27.3,2 27.3,18.5c0,8.6 -8.2,12.2 -15.8,12.2c-5.6,0 -10.2,-2.1 -13.2,-7l-0.3,0l0,6.1l-3.9,0l0,-14l0,0Z"
          fill={COLORS[variant].primary}
        />
        <path
          d="M259.3,75.9l9,0l0,-33.5l-9,0l0,-3.4l13.4,0l0,36.9l7.2,0l0,3.4l-20.6,0l0,-3.4l0,0ZM272.7,29.1l-5.6,0l0,-6.1l5.6,0l0,6.1Z"
          fill={COLORS[variant].primary}
        />
        <path
          d="M330.1,42.4l-6.9,0l0,33.7c0,12.1 -4.7,18.9 -18.5,18.9c-7.5,0 -16.8,-2.8 -16.7,-11.9l4.5,0c1,6.5 7,8.5 12.5,8.5c11.3,0 13.7,-7.1 13.7,-17.2l0,-3.8l-0.2,0c-3.3,5.9 -8.1,8.2 -14.8,8.2c-11.3,0 -18.5,-8.9 -18.5,-20.1c0,-11.1 5.8,-20.6 18.3,-20.6c6.4,0 12,2.2 15,8.1l0.2,0l0,-7.2l11.4,0l0,3.4ZM304.7,75.4c10.7,0 14.1,-8.7 14,-17.6c0.1,-9 -4.7,-16.3 -14,-16.3c-9.5,0 -14.4,8.2 -14.4,16.3c0,9.6 4.7,17.6 14.4,17.6Z"
          fill={COLORS[variant].primary}
        />
        <path
          d="M333.7,75.9l7.2,0l0,-51.8l-7.2,0l0,-3.4l11.6,0l0,24.5l0.2,0c2.4,-4.7 7.4,-7.2 12.6,-7.2c15.4,0 14.4,11.5 14.4,20.6l0,17.2l6.7,0l0,3.4l-18.4,0l0,-3.4l7.2,0l0,-17.1c0,-9.8 0.4,-17 -10.2,-16.7c-10.5,0 -12.5,8.3 -12.5,16.7l0,17.2l7.2,0l0,3.4l-18.8,0l0,-3.4Z"
          fill={COLORS[variant].primary}
        />
        <path
          d="M408,42.4l-13.3,0l0,23.8c0,5.6 0.4,10 5.3,10c4.7,0 5.7,-3.5 5.7,-9.2l4.5,0c0,8.2 -2.4,13.2 -10.7,13.2c-7.8,0 -9.3,-6.9 -9.3,-12.5l0,-25.3l-7.5,0l0,-3.4l7.5,0l0,-9.6l4.5,-1.7l0,11.3l13.3,0l0,3.4Z"
          fill={COLORS[variant].primary}
        />
      </g>
    </svg>
  );
};

InsightLogo.propTypes = {
  variant: PropTypes.oneOf(['color', 'bw']),
  height: PropTypes.number,
  style: PropTypes.object,
};

export default InsightLogo;
